import Cookies from 'js-cookie';

export default function Geolocation() {
  document.addEventListener("DOMContentLoaded", async () => {
    const htmlLang = document.querySelector('html').lang.toLowerCase();
    const cookieLang = Cookies.get('lang') || '';

    if (htmlLang.split('-')[0] === cookieLang.split('-')[0]) {
      console.log('cookie lang');
      return;
    }

    if (window.location.search && window.location.search.includes('?lo')) {
      console.log('search param lang');
      return;
    }

    if (!geoip_detect) {
      console.log('no geo redirect');
      return;
    };

    const record = await geoip_detect.get_info()
    if (record.error()) {
      console.error('WARNING Geodata Error:' + record.error() );
    }

    const country = record.data.country.iso_code.toLowerCase();
    console.log('geo = '+country);

    // If in brazil and page is in english
    if (country === 'br' && htmlLang !== 'pt-br') {
      const altPage = document.querySelector('link[hrefLang="pt-br"]')
      if (altPage && altPage.href) {
        window.location = altPage.href;
      }
    }

    // If NOT in brazil and page is in portuguese
    if (country !== 'br' && htmlLang === 'pt-br') {
      const altPage = document.querySelector('link[hrefLang="en"]')
      if (altPage && altPage.href) {
        window.location = altPage.href;
      }
    }

  });

}
